import { Color } from "@lib/color";

interface Branding {
	vendor:string;
	logo:string;
	reportLogo:string;
	favIcon:string;
}

interface Themes {
	primaryColor:string;
	reports: {
		stripBar1Color:string;
		stripBar3Color:string;
	}
}

interface Support {
	supportEmail:string,
	supportDeskDetails:{
		departmentId:string,
		layoutId:string,
		widgetId:string,
		orgId:string
	}
}

export interface Configs {
	isWhiteLabel: boolean;
	branding: Branding;
	themes: Themes;
	support: Support;
}

export class ConfigStore {
	static configs: Configs;

	static setConfig(data: Configs) {
		ConfigStore.configs = data;
	}

	static get(path: string) {
		if (!ConfigStore.configs) return undefined;

		return path.split('.').reduce((obj: any, key: string) => {
			if (obj && typeof obj === 'object' && key in obj) {
	  			return obj[key];
			}

			return undefined;
		}, ConfigStore.configs);
	}

	static primaryColor() {
		const color=ConfigStore.get('themes.primaryColor');

		return Color.html(color) ?? Color.hsv(229,0.68,1);
	}
}